export default __webpack_public_path__ + "static/media/icon-workflow.5d622d07.svg";